export type CommunitySectionKey = "rooms" | "channels" | "messages";

export const COMMUNITY_SECTION_ORDER: CommunitySectionKey[] = [
  "rooms",
  "channels",
  "messages",
];

export const parseCommunitySection = (
  value?: string | null,
): CommunitySectionKey => {
  if (value === "channels" || value === "messages") {
    return value;
  }

  return "rooms";
};
